import styles from "../../assets/styles/Subscription/Subscription.module.scss";
import {
  AppPage,
  MimaTable,
  BusinessInsightComponent as BIC,
  MimaText,
  MimaButton,
} from "../../components";
import React, { useState } from "react";
import { amountFormatter } from "../../utils/utils";
import moment from "moment";
import { useMemo } from "react";
import constant from "../../utils/constant";
import { subscriptionStore } from "../../stores";
import { downloadXlsx2 } from "../../utils/download";
import { GiveSubscriptionContainer } from "../../containers";
import { AnimatePresence } from "framer-motion";

const Subscription = ({
  isLoading,
  data,
  isFetching,
  onLimitChange,
  setFilterQuery,
  setSearchQuery,
  limit,
  currentPage,
  setCurrentPage,
  subscriptionAnalysis,
  goToGiveSubscription,
  giveSubscriptionModal,
  closeModal,
}) => {
  const [item, setItem] = useState({});
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Subscription Plan",
      accessor: "name",
      Cell: ({ cell }) => {
        const subscriptionPlan = cell.row.original?.plan?.name;
        return <span>{subscriptionPlan}</span>;
      },
    },
    {
      Header: "Duration",
      accessor: "duration",
      Cell: ({ cell }) => {
        const duration = cell.row.original?.months;
        return <span>{`${duration} Month(s)`}</span>;
      },
    },
    {
      Header: "Subscription Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const subscriptionDate = cell.row.original?.createdAt;
        return (
          <span>{moment(subscriptionDate).format("DD/MM/YYYY HH:mm a")}</span>
        );
      },
    },
    {
      Header: "Amount",
      accessor: "amountPaid",
      Cell: ({ cell }) => {
        const amount = cell.value;
        const currencyCode = cell.row.original.currencyCode;
        const formattedAmount = amountFormatter(currencyCode).format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Expiration Date",
      accessor: "expiryDate",
      Cell: ({ cell }) => {
        const expirationDate = cell.row.original?.expiryDate;
        return (
          <span>{moment(expirationDate).format("DD/MM/YYYY HH:mm a")}</span>
        );
      },
    },
    {
      Header: "Grace End Date",
      accessor: "graceEndDtae",
      Cell: ({ cell }) => {
        const graceEndDate = cell.row.original?.graceEndDate;
        return <span>{moment(graceEndDate).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value;
        const statusClass = `status ${
          status === "ACTIVE"
            ? "status__green"
            : status === "RENEWED"
              ? "status__grey"
              : status === "CHANGE-PLAN"
                ? "status__green2"
                : status === "VOID"
                  ? "status__dark__yellow"
                  : "status__red"
        }`;
        return <span className={statusClass}>{status}</span>;
      },
    },
    {
      Header: "Action",
      Cell: ({ cell }) => {
        const item = cell.row.original;

        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setItem(item);
              goToGiveSubscription();
            }}
          >
            Give Subscription
          </span>
        );
      },
    },
  ];

  const printData = tableData.map((item) => ({
    "Business Name": item?.business.tradingName || "",
    "Subscription Plan": item?.plan?.name || "",
    Duration: `${item?.months} month(s)` || "",
    "Subscription Date": moment(item.createdAt).format("DD/MM/YYYY HH:mm a"),
    Amount: amountFormatter(item.currencyCode).format(item.amountPaid),
    "Expiration Date": moment(item.expiryDate).format("DD/MM/YYYY HH:mm a"),
    "Grace End Date": moment(item.graceEndDate).format("DD/MM/YYYY HH:mm a"),
    Status: item.status,
  }));

  return (
    <AppPage pageTitle="Subscriptions">
      <>
        {subscriptionAnalysis.map((plan) => (
          <>
            <MimaText variant="bodyBold">{`${plan.plan} Subscription Plan Analysis`}</MimaText>
            <div className={styles.metrics} key={plan.plan}>
              {plan.statuses.map((analysis, i) => (
                <BIC
                  mb={15}
                  title={analysis.status}
                  amount={analysis.totalCount}
                  styleClass={
                    analysis.status === "ACTIVE"
                      ? "cards_green_1"
                      : analysis.status === "EXPIRED"
                        ? "cards_red_1"
                        : analysis.status === "VOID"
                          ? "cards_yellow_1"
                          : analysis.status === "RENEWED"
                            ? "cards_green_2"
                            : analysis.status === "CHANGE-PLAN"
                              ? "cards_blue_2"
                              : "cards_yellow_2"
                  }
                />
              ))}
            </div>
          </>
        ))}

        <MimaButton
          title={`Download Subscription Report`}
          onClick={() => {
            downloadXlsx2(printData, "Subscription Report");
          }}
          mt={4}
        />

        <MimaTable
          tableData={tableData}
          tableColumns={tableColumns}
          searchPlaceholder="Search Subscription"
          searchVariant="wide"
          totalItems={data?.data?.totalCounts}
          onLimitChange={onLimitChange}
          isLoading={isLoading}
          isFetching={isFetching}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
        />
      </>

      {giveSubscriptionModal && (
        <di className="modal">
          <AnimatePresence>
            {giveSubscriptionModal && (
              <GiveSubscriptionContainer item={item} closeModal={closeModal} />
            )}
          </AnimatePresence>
        </di>
      )}
    </AppPage>
  );
};

export default Subscription;
